import React, {useEffect, useRef, useState} from "react";
import styles from './Home.module.css';
import SideBar from "../SideBar/SideBar";
import StatusBadge from "../StatusBadge/StatusBadge";
import ActionDropdown from "./ActionDropdown/ActionDropdown";
import axios from "axios";
import Cookies from 'js-cookie';

const Modal = ({ isOpen, onClose, message }) => {
    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <p>{message}</p>
                <button onClick={onClose}>Закрыть</button>
            </div>
        </div>
    );
};

const ConfirmModal = ({ isOpen, onConfirm, onCancel, message }) => {
    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <p>{message}</p>
                <div className={styles.modalButtons}>
                    <button onClick={onConfirm}>Да</button>
                    <button onClick={onCancel}>Нет</button>
                </div>
            </div>
        </div>
    );
};

const TableComponent = ({options, data, setData, initialData, onSend, currentStep, setCurrentStep, serverIP}) => {
    const [dropdownSelect, setDropdownSelect] = useState(null);
    const dropdownRef = useRef([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [teamName, setTeamName] = useState("");
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [gameOver, setGameOver] = useState(false);

    useEffect(() => {
        fetchTeamData();
    }, []);

    /*useEffect(() => {
        const handleClickOutside = (event) => {
            if (!dropdownRef.current.some(ref => ref && ref.contains(event.target))) {
                setDropdownSelect(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);*/

    const handleDropdownOpen = (index) => {
        setDropdownSelect(index === dropdownSelect ? null : index);
    };

    const fetchTeamData = async () => {
        try {
            const teamId = Cookies.get('team_id');
            const response = await axios.get(`${serverIP}/v1/team?team_id=${teamId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`
                }
            });
            
            const result = response.data;
            setGameOver(result.game_over);

            const formattedData = result.workers
                .map((worker) => ({
                    person: worker.person,
                    sortOrder: worker.sort_order,
                    department: worker.department,
                    position: worker.position,
                    name: worker.name,
                    involvement: worker.involvement,
                    status: worker.status,
                    action: worker.action.title,
                    sort_order: worker.sort_order,
                    options: worker.options.map(option => ({
                        id: option.action_id,
                        title: option.title,
                        all_team: option.all_team,
                    })),
                }))
                .sort((a, b) => a.sort_order - b.sort_order);

            setTeamName(result.name || "");
            setData(formattedData);
            setCurrentStep(result.current_step);
        } catch (error) {
            console.error('Ошибка загрузки данных команды:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClearActions = async (serverIP) => {
        const teamId = parseInt(Cookies.get('team_id'), 10);
        try {
            await axios.post(
                `${serverIP}/v1/team/actions/throw`,
                { team_id: teamId },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`
                    }
                }
            );

            console.log('Сброс активности успешно выполнен');
            await fetchTeamData();
        } catch (error) {
            console.error('Ошибка сброса активностей:', error);
            if (error.response) {
                console.error('Детали ошибки:', error.response.data);
            }
        }
    };

    const handleSend = async () => {
        const allFieldsFilled = data.every((row) => row.action);
        if (!allFieldsFilled) {
            setModalMessage(`Чтобы отправить шаг ${currentStep}, вам нужно заполнить все поля.`);
            setIsModalOpen(true);
            return;
        }

        const teamId = parseInt(Cookies.get('team_id'), 10);
        try {
            const response = await axios.post(
                `${serverIP}/v1/team/step/next`,
                { team_id: teamId },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`
                    }
                }
            );

            const updatedTeamData = response.data;
            console.log('Обновленные данные команды:', updatedTeamData);
            setCurrentStep(updatedTeamData.current_step);
            await fetchTeamData();
        } catch (error) {
            console.error('Ошибка отправки следующего шага:', error);
            if (error.response) {
                console.error('Детали ошибки:', error.response.data);
            }
        }
    };

    const handleSendWithConfirmation = () => {
        const allFieldsFilled = data.every((row) => row.action);
        
        if (!allFieldsFilled) {
            setModalMessage(`Чтобы отправить шаг ${currentStep}, вам нужно заполнить все поля.`);
            setIsModalOpen(true);
            return;
        }
        
        setIsConfirmModalOpen(true);
    };

    const handleSelectOption = async (index, option) => {
        const actionId = option.id;
        if (!actionId) {
            console.error('Некорректный option:', option);
            return;
        }

        const selectedWorker = data[index];
        const teamId = parseInt(Cookies.get('team_id'), 10);
        const personId = selectedWorker.person;

        if (!teamId || !personId) {
            console.error('Некорректные данные для запроса:', {
                teamId,
                person_id: personId,
                action_id: actionId,
            });
            return;
        }

        const updatedData = data.map((row, rowIndex) =>
            rowIndex === index
                ? { ...row, action: option }
                : row
        );

        try {
            const response = await axios.post(
                `${serverIP}/v1/team/action/new`,
                {
                    team_id: teamId,
                    person_id: personId,
                    action_id: actionId
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`
                    }
                }
            );

            const updatedTeamData = response.data;
            console.log('Данные команды обновлены:', updatedTeamData);
            setData(updatedData);
            setDropdownSelect(null);

            if (option.all_team) {
                fetchTeamData();
            }
        } catch (error) {
            console.error('Ошибка обновления активности:', error);
            if (error.response) {
                console.error('Детали ошибки:', error.response.data);
            }
        }
    };

    const calculateTotalInvolvement = () => {
        return data.reduce((sum, row) => sum + (parseInt(row.involvement, 10) || 0), 0);
    };

    return (
        <div className={styles.mainPage}>
            {isLoading ? (
                <p>Загрузка данных...</p>
            ) : (
                <div className={styles.tableMain} style={{ flex: 1 }}>
                    <div className={styles.tableMain} style={{ flex: 1 }}>
                        <div className={styles.titles}>
                            <h2 className={styles.titleBc} data-aos="fade-right">{teamName}</h2>
                            <h2 className={`${styles.titleBc} ${styles.orange}`} data-aos="fade-left">{currentStep}</h2>
                        </div>
                        <table border="0" className={styles.table} data-aos="fade">
                            <thead>
                                <tr>
                                    <th>Отдел</th>
                                    <th>Должность</th>
                                    <th>Имя</th>
                                    <th style={{width: "15%"}}>Текущая вовлечённость</th>
                                    <th>Текущий типаж</th>
                                    <th className={styles.actionCell}>Активность</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((row, index) => (
                                    <tr key={index}>
                                        <td className={styles.departmentColumn} >{row.department}</td>
                                        <td>{row.position}</td>
                                        <td>{row.name}</td>
                                        <td>{row.involvement}</td>
                                        <td>
                                            <StatusBadge status={row.status} />
                                        </td>
                                        <td>
                                            <ActionDropdown
                                                row={row}
                                                index={index}
                                                isOpen={dropdownSelect === index}
                                                onToggle={() => handleDropdownOpen(index)}
                                                onSelect={(option) => handleSelectOption(index, option)}
                                                dropdownRef={dropdownRef}
                                                rowIndex={index}
                                            />
                                        </td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style={{padding: 0, fontWeight: 700, fontSize: 20}}>{calculateTotalInvolvement()}</td>
                                </tr>
                            </tbody>
                        </table>
                        {!gameOver && (
                            <div className={styles.btnContainer}>
                                <button className={`${styles.btn} ${styles.fill}`} onClick={handleSendWithConfirmation}>
                                    Отправить
                                </button>
                                <button
                                    className={`${styles.btn} ${styles.transparent}`}
                                    onClick={() => handleClearActions(serverIP)}
                                >
                                    Очистить
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {isModalOpen && (
                <Modal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    message={modalMessage}
                />
            )}
            {isConfirmModalOpen && (
                <ConfirmModal
                    isOpen={isConfirmModalOpen}
                    onConfirm={() => {
                        setIsConfirmModalOpen(false);
                        handleSend();
                    }}
                    onCancel={() => setIsConfirmModalOpen(false)}
                    message="Вы уверены, что хотите отправить текущий шаг?"
                />
            )}
        </div>
    );
};

function Home({isAdmin, options, initialData, data, setData, setOptions, onSend, currentStep, setCurrentStep, serverIP}) {
    return (
        <div className="App">
            <SideBar blueHome={{backgroundColor: "#0170ba", color: "#fff"}} isAdmin={isAdmin}/>
            <div style={{ marginTop: "80px" }}>
                <TableComponent
                    options={options}
                    initialData={initialData}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    onSend={onSend}
                    data={data}
                    setData={setData}
                    serverIP={serverIP}
                />
            </div>
        </div>
    );
}

export default Home;